var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader",style:({
    left: _vm.leftDrawerSize + 'px'
  })},[_c('div',{staticClass:"absolute-center",staticStyle:{"width":"20vmin","height":"20vmin"}},[_c('q-spinner',{attrs:{"size":"100%"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }